import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [bannerVisible, setBannerVisible] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  useEffect(() => {
    // Initial State setzen basierend auf aktueller Scroll-Position
    const initialScrollY = window.scrollY
    setScrolled(initialScrollY > 50)
    setBannerVisible(initialScrollY < 10)
    setLastScrollY(initialScrollY)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      
      // Mobile-Menü beim Scrollen schließen
      if (mobileMenuOpen) {
        setMobileMenuOpen(false)
      }
      
      // Banner-Sichtbarkeit bestimmen
      if (currentScrollY < 10) {
        setBannerVisible(true)
      } else if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setBannerVisible(false)
      } else if (currentScrollY < lastScrollY) {
        setBannerVisible(true)
      }
      
      setScrolled(currentScrollY > 50)
      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY, mobileMenuOpen])

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''} ${!bannerVisible ? 'banner-hidden' : ''}`}>
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo-container" onClick={closeMobileMenu}>
            <img src="/spotxlogo.png" alt="spotx Logo" className="logo" />
            <span className="popular-badge">Popular App</span>
          </Link>
          <button 
            className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Menü öffnen/schließen"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <a href="#features" onClick={closeMobileMenu}>Features</a>
            <a href="#how-it-works" onClick={closeMobileMenu}>So funktioniert's</a>
            <a href="#screenshots" onClick={closeMobileMenu}>App</a>
            <a href="#rewards" onClick={closeMobileMenu}>Belohnungen</a>
            <Link to="/merchant-center" onClick={closeMobileMenu}>Merchant Center</Link>
            <a href="#faq" onClick={closeMobileMenu}>FAQ</a>
            <a href="#cta" className="cta-button" onClick={closeMobileMenu}>Jetzt starten</a>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
